import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ACTION_GIFT_ORDER_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getGiftsOrdersSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/action_gift_order`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerActionGiftOrder(args) {
    const user = yield select(state => state.user);
    const pagination = yield select(state => state.pagination);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const filterUser = yield select(state => state.filterUser);
    const giftsStatusFilterOptions = yield select(state => state.giftsStatusFilterOptions);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('gift_order_id', args.data.gift_order_id);
        formData.append('action_type', args.data.action_type);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(getGiftsOrdersSagaAction({
                establishment: currentEstablishment,
                page: pagination.current,
                user: filterUser.user.id,
                status: JSON.stringify(giftsStatusFilterOptions.filter(el => el.active).map(el => el.id))
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherActionGiftOrder() {
    yield takeLatest(ACTION_GIFT_ORDER_SAGA, workerActionGiftOrder);
}